// @flow
import { int } from "../helpers/types";

export type Auction = {
  id: number,
  title: string,
  active: boolean,
  calendar: boolean,
  url: string,
  image: ?string,
  start: Date,
  end: Date
};

export type AuctionsApiItemViewingTime = {
  avt_id: string,
  avt_date: string,
  avt_start_time: string,
  avt_end_time: string,
  avt_start_datetime: string,
  avt_end_datetime: string,
  avt_location: {
    loc_id: string,
    loc_description: string,
    loc_address: string,
    loc_country: string,
    loc_postal_code: string,
    loc_route_map: ?string,
    loc_town: string
  }
};
export type AuctionsApiItemSession = {
  ses_id: string,
  ses_catalogue_number_start: string,
  ses_catalogue_number_end: string,
  ses_description: string,
  ses_start_datetime: string,
  ses_end_datetime: string,
  ses_finish_datetime: ?string,
  ses_finish_online_bidding_datetime: ?string
};
export type AuctionsApiItem = {
  auc_id: string,
  auc_image: ?string,
  auc_start_datetime: string,
  auc_end_datetime: string,
  auc_title: string,
  auc_url_front_end: string,
  auc_planned_start_live_bidding_datetime: ?string,
  auc_live_bidding_started: boolean,
  auc_live_stream_url: ?string,
  auc_show_in_calendar: boolean,
  auc_active_front_end: boolean,
  auc_memo_next_auction?: ?string,
  auc_memo_openinghours_collect?: ?string,
  auc_memo_openinghours_contribute?: ?string,
  auc_memo_viewing_times?: ?string,
  auc_viewing_times?: Array<AuctionsApiItemViewingTime>,
  auc_sessions?: Array<AuctionsApiItemSession>,
  auc_contribution_until_date?: ?string,
  auc_collection_until_date?: ?string
};

export default function modelAuction(item: AuctionsApiItem): Auction {
  return {
    id: int(item.auc_id),
    title: item.auc_title,
    active: item.auc_active_front_end,
    calendar: item.auc_show_in_calendar,
    url: item.auc_url_front_end,
    image:
      item.auc_image && item.auc_image !== "files/"
        ? `${item.auc_url_front_end}/${item.auc_image}`
        : null,
    start: new Date(item.auc_start_datetime),
    end: new Date(item.auc_start_datetime)
  };
}



// WEBPACK FOOTER //
// ./src/redux/models/auction.js